import type { CombinedSampleResponse } from '~/clients'

/**
 * The combined-sample overview endpoints can return full rows as well as response
 * variants that omit identifying fields for anonymized group/community samples.
 */
export type PortalCombinedSampleListItem = Partial<CombinedSampleResponse> &
  Pick<CombinedSampleResponse, 'kindOf' | 'id' | 'product' | 'status' | 'level'> & {
    isAnonymised?: boolean
  }

export enum SampleStatus {
  None = 'None',
  Analysed = 'Analysed',
  Copied = 'Copied',
  Elapsed = 'Elapsed',
  Final = 'Final',
  Taken = 'Taken',
  Planned = 'Planned',
}

export enum SampleLevel {
  None = 'None',
  Own = 'Own',
  Community = 'Community',
  Copied = 'Copied',
  Group = 'Group',
}
